import React, { Children, useState } from "react";
import Pagination from "@mui/material/Pagination";

// import JS files
import { useUserData } from "../../context/UserDataContext";
import MuiTheme from "./MuiTheme";

// import Others files

const MuiPagination = ({ count,page , onChange }) => {
  return (
    <>
      <MuiTheme>
        <div className="flex justify-center items-center mt-6">
          <Pagination onChange={onChange} count={count} page={page} color="primary" />
        </div>
      </MuiTheme>
    </>
  );
};

export default MuiPagination;
